import { Injectable } from '@angular/core';
import { CustomerUserQueryInput } from 'app/backend/api';

@Injectable()
export class CustomerUserParams {
    public orderBy: 'name' | 'email' = 'name';
    public searchValue = '';
    public selectedCompany = '';
    public selectedApplication = '';

    public query: CustomerUserQueryInput = {
        search: '',
        customerId: '',
        orderBy: 'name',
        applicationIds: []
    };
}
